// extracted by mini-css-extract-plugin
export var acitonButtons = "_m3-0";
export var additionalIcon = "_m3-f";
export var block = "_m3-1";
export var blockContent = "_m3-7";
export var blockDescription = "_m3-8";
export var blockIcon = "_m3-9";
export var blockTitle = "_m3-6";
export var border = "_m3-a";
export var center = "_m3-l";
export var edge = "_m3-b";
export var edgeLabel = "_m3-c";
export var edgePath = "_m3-d";
export var error = "_m3-e";
export var flowchart = "_m3-g";
export var flowchartContent = "_m3-h";
export var highlighted = "_m3-3";
export var hover = "_m3-4";
export var icon = "_m3-i";
export var left = "_m3-m";
export var navButton = "_m3-j";
export var navButtons = "_m3-k";
export var right = "_m3-n";
export var selected = "_m3-2";
export var small = "_m3-5";